<template>
  <Modal v-model="visible" :mask-closable="false" title="跟进" :footer-hide="true" width="750">
    <div class="follow-up-container">
      <div class="fee-status">
        <Form ref="form" :model="form" :label-width="80" class="modal-form" :rules="ruleInline">
          <FormItem label="续费状态">
            <RadioGroup v-model="form.payState" @on-change="changePayState">
              <Radio :label="2">续费成功</Radio>
              <Radio :label="3">续费失败</Radio>
              <Radio :label="1">待续费</Radio>
            </RadioGroup>
          </FormItem>

          <div v-if="form.payState == 2">
            <Table :columns="columns" :data="form.commissionDTOList">
              <template slot-scope="{ row, index }" slot="fee">
                <Input v-model="row.fee" placeholder="请填写" @on-change="form.commissionDTOList[index].fee = row.fee" @on-blur="payableTotal('fee')"></Input>
              </template>

              <template slot-scope="{ row, index }" slot="payFee">
                <FormItem
                  class="form-item"
                  :prop="'commissionDTOList.' + index + '.payFee'"
                  :style="{ marginTop: isList ? '10px' : '22px' }"
                  :rules="{ required: true, message: '请输入', trigger: 'blur' }"
                >
                  <Input
                    class="table-input"
                    v-model="row.payFee"
                    placeholder="请填写"
                    @on-change="form.commissionDTOList[index].payFee = row.payFee"
                    @on-blur="payableTotal('payFee')"
                  ></Input>
                </FormItem>
              </template>
            </Table>

            <div class="total">
              <div>合计</div>
              <div>{{ feeTotal ? feeTotal : '' }}</div>
              <div>{{ payFeeTotal ? payFeeTotal : '' }}</div>
            </div>

            <FormItem prop="serverEndDate" label="续费时间">
              <DatePicker type="date" split-panels v-model="form.serverEndDate" placeholder="请选择"></DatePicker>
            </FormItem>
          </div>

          <FormItem
            v-if="form.payState == 3 || form.payState == 1"
            prop="serviceStateDetail"
            :key="form.payState == 3 ? 'error' : 'other'"
            :label="form.payState == 3 ? '失败类型' : '其他类型'"
            :rules="$units.formRule.required(`请选择${form.payState == 3 ? '失败' : '其他'}类型`)"
            style="margin-bottom: 30px"
          >
            <div class="failure-type">
              <div
                class="failure-btn"
                :class="{ active: item.value == form.serviceStateDetail }"
                v-for="item in failureType"
                @click="selectedFailType(item)"
                :key="item.value"
              >
                {{ item.label }}
              </div>
            </div>
          </FormItem>

          <FormItem
            key="beizhu1"
            prop="serviceContent"
            label="备注"
            v-if="form.payState == 3"
            :rules="{ required: true, message: '请填写失败原因', trigger: 'change' }"
          >
            <Input style="width: 560px" v-model="form.serviceContent" placeholder="请填写续费失败原因" maxlength="50" show-word-limit type="textarea" />
          </FormItem>

          <FormItem key="beizhu2" label="备注" v-if="form.payState == 1" prop="serviceContent">
            <Input style="width: 560px" v-model="form.serviceContent" placeholder="请填写备注" maxlength="50" show-word-limit type="textarea" />
          </FormItem>
        </Form>
      </div>

      <div class="action-buttom">
        <div class="buttom-box">
          <Button class="cancel" @click="visible = false">取消</Button>
          <Button type="primary" @click="ok">确认</Button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import filters from '@/api/filter';
export default {
  props: ['id', 'isList', 'getInsureList'],
  data() {
    return {
      commissionDTOList: [],
      visible: false,
      columns: [
        {
          title: '险种名称',
          key: 'productName',
          align: 'center'
        },
        {
          title: '应缴保费(元)',
          align: 'center',
          slot: 'fee'
        },
        {
          title: '实缴保费(元)',
          align: 'center',
          slot: 'payFee'
        }
      ],
      failureType: [],
      form: {
        payState: 2,
        serviceStateDetail: '',
        serverEndDate: '',
        commissionDTOList: []
      },
      ruleInline: {
        serverEndDate: [{ required: true, type: 'date', message: '请选择时间', trigger: 'change' }]
      },
      feeTotal: '', //应缴总计
      payFeeTotal: '' //实缴总计
    };
  },

  methods: {
    open(commissionDTOList) {
      this.$refs.form.resetFields();

      this.form.commissionDTOList =
        commissionDTOList &&
        commissionDTOList.map(item => {
          return {
            ...item,
            fee: item.fee ? item.fee : '',
            payFee: item.payFee ? item.payFee : ''
          };
        });
      this.commissionDTOList = this.form.commissionDTOList;
      this.feeTotal = this.form.commissionDTOList && this.form.commissionDTOList.reduce((sum, current) => sum + Number(current['fee']), 0);
      this.payFeeTotal = this.form.commissionDTOList && this.form.commissionDTOList.reduce((sum, current) => sum + Number(current['payFee']), 0);
      this.visible = true;
    },

    // 计算
    payableTotal(keys) {
      if (keys == 'fee') {
        this.feeTotal = this.form.commissionDTOList.reduce((sum, current) => sum + Number(current[keys]), 0);
      } else {
        this.payFeeTotal = this.form.commissionDTOList.reduce((sum, current) => sum + Number(current[keys]), 0);
      }
    },

    // 选择续费状态
    changePayState(value) {
      this.$refs.form.resetFields();
      this.form = {
        payState: value,
        serviceStateDetail: ''
      };

      if (value == 3) {
        this.failureType = [
          {
            label: '豁免保费',
            value: '1'
          },
          {
            label: '已终止',
            value: '2'
          },
          {
            label: '已过宽限期',
            value: '3'
          },
          {
            label: '健康原因',
            value: '4'
          },
          {
            label: '产品原因',
            value: '5'
          },
          {
            label: '经济原因',
            value: '6'
          },
          {
            label: '已退保',
            value: '7'
          },
          {
            label: '其他',
            value: '8'
          }
        ];
      } else if (value == 1) {
        this.failureType = [
          {
            label: '无法联系',
            value: '9'
          },
          {
            label: '有意向退保',
            value: '10'
          },
          {
            label: '准备续费',
            value: '11'
          },
          {
            label: '跟进完成',
            value: '13'
          },
          {
            label: '跟进终止',
            value: '14'
          },
        ];
      } else if (value == 2) {
        this.form.commissionDTOList = this.commissionDTOList;
      }
    },

    // 失败类型
    selectedFailType(item) {
      this.form.serviceStateDetail = item.value;
    },

    ok() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        this.submit();
      });
    },

    submit() {
      let data = {
        id: this.id,
        serviceState: 2,
        payState: this.form.payState,
        serverEndDate: this.form.serverEndDate ? filters.filterTime(this.form.serverEndDate, 'YYYY-MM-DD') : '',
        additionData: this.form.commissionDTOList,
        serviceContent: this.form.serviceContent,
        serviceStateDetail: this.form.serviceStateDetail
      };

      this.$http({
        url: `/buz/policyRenewalRecord/updateRenewalRecord`,
        type: 'POST',
        data,
        apiPermissionCode: 'renewalManage_02_7'
      }).then(res => {
        this.$notice.success('操作成功');
        if (this.isList) {
          this.getInsureList();
        } else {
          this.$emit('updatePolicyData');
        }
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.follow-up-container {
  padding: 0 0 5px 10px;
  .fee-status {
    .total {
      display: flex;
      border: 1px solid #e8eaec;
      border-top: none;
      border-right: none;
      height: 40px;
      margin-bottom: 20px;
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.23%;
        border-right: 1px solid #e8eaec;
      }
    }
    .failure-type {
      display: flex;
      flex-wrap: wrap;
      .failure-btn {
        width: 105px;
        height: 32px;
        border-radius: 4px;
        background: #f5f7f9;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #3c464f;
        font-size: 14px;
        margin-bottom: 10px;
        margin-right: 10px;
      }

      .failure-btn:hover {
        cursor: pointer;
      }

      & .active {
        background: rgba(235, 241, 255, 0.39);
        color: #236dff;
        border: 1px solid #236dff;
      }
    }
    /deep/ .ivu-form-item-content {
      margin-left: 0 !important;
    }
    .form-item {
      // margin-top:10px;
      height: 55px;
      display: flex;
      align-items: center;
    }
    .table-input {
      margin-right: 100px !important;
    }
  }
}
.action-buttom {
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  .buttom-box {
    width: 50%;
    display: flex;
    justify-content: center;
    justify-content: space-between;
    Button {
      width: 140px;
      height: 36px;
    }
    .cancel {
      width: 120px;
      border-color: #236dff;
      color: #236dff;
    }
  }
}
</style>
